import firebase from 'firebase/app'
import 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyDOu4Y8X8wu--xBRQigqsBcYTZdymq6_3w",
    authDomain: "table-tennis-4d093.firebaseapp.com",
    databaseURL: "https://table-tennis-4d093.firebaseio.com",
    projectId: "table-tennis-4d093",
    storageBucket: "table-tennis-4d093.appspot.com",
    messagingSenderId: "706931287449",
    appId: "1:706931287449:web:222880bbcafb8fea61df08"
  };
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

export default db;